// extracted by mini-css-extract-plugin
export default {"error":"LinkedinSlide_error__XzXJI","image":"LinkedinSlide_image__NHca-"};